import React, { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { GenerateInvoiceData } from "./Data/GenerateInvoice.data";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";

const GenerateInvoiceList = () => {
  const GenerateInvoiceRef = useRef(null);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [FormData, setFormData] = useState(GenerateInvoiceData);

  const handleCombine = () => {
    setShowAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setShowAcceptModal(false);
    // setPoNumber("");
  };

  const Options = [
    { value: "1", label: "CP10- XXXXXXXXXXX" },
    { value: "2", label: "CP9 - YYYYYYYYYYY" },
    { value: "3", label: "CP5 - YYYYYYYYYYY" },
    { value: "4", label: "CP10- XXXXXXXXXXX" },
    { value: "5", label: "CP7 - LLLLLLLLLLL" },
    { value: "6", label: "CP811- XXXXXXXXX" },

  ];

  return (
    <div className="generate-invoice-list-page">
      <div className="crud-requirement-list">
        <div className="corporate-member-list">
          <div className="sgbp-category">
            <div className="row status-input pr-0 col-9">
              <FormCreator ref={GenerateInvoiceRef} {...FormData} />
            </div>
            <div className="d-flex align-items-end mb-3 mt-auto gap-3">
              <Buttons
                buttonText="Search"
                buttonTypeClassName="search-btn "
              // onClick={handleSearch}
              />
              <Buttons
                buttonText="Clear"
                buttonTypeClassName="btn btn-secondary"
              // onClick={handleClearClick}
              />
            </div>
          </div>
          <div className="member-list">
            <div className="content-section">
              {/* Left Table */}
              <div className="table-section">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Application Number</th>
                      <th>Company Name</th>
                      <th>Cert Number</th>
                      <th>Item Code</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS001</td>
                      <td>Company A</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                            // value={props.value}
                            // value={""} /
                            options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS002</td>
                      <td>Company A</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                            // value={props.value}
                            // value={""} /
                            options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS003</td>
                      <td>Company A</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                        <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                          // value={props.value}
                          // value={""} /
                          options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS004</td>
                      <td>Company B</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                          // value={props.value}
                          // value={""} /
                          options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS005</td>
                      <td>Company A</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                          // value={props.value}
                          // value={""} /
                          options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS006</td>
                      <td>Company B</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                          // value={props.value}
                          // value={""} /
                          options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input type="checkbox" />
                      </td>
                      <td className="company ">SGBCPS007</td>
                      <td>Company C</td>
                      <td>SGBP009</td>
                      <td>
                        <div className="form-group">
                          <Select
                            className="custom-checkbox-select"
                            placeholder="Select"
                          // value={props.value}
                          // value={""} /
                          options={Options}

                          // onChange={props.onChange}
                          // onBlur={props.onBlur}
                          // options={props.options}
                          // isMulti={props.isMultiSelect}
                          // placeholder={props.placeholder}
                          // isDisabled={true}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between mt-5">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="black-btn"
            // onClick={handleBack}
            />
            <div className="d-flex gap-3">
              <Buttons
                buttonText="Combine"
                buttonTypeClassName="success-btn"
                onClick={handleCombine}
              // isLoading={isChangeKeyPosition}
              // isDisable={isChangeKeyPosition}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <CenterModel
        show={showAcceptModal}
        handleClose={closeAcceptModal}
        modelTitle="Combine Invoice"
      >
        <label className="form-check-label" htmlFor="flexRadioDefault">
          Push to Xero
        </label>
        <div className="radio-group generate-invoice-model d-flex gap-4 mt-2 mb-4">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
            // checked={isPoNumberRequired}
            // onChange={() => setIsPoNumberRequired(true)}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault1">
              Yes
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
            // checked={!isPoNumberRequired}
            // onChange={() => setIsPoNumberRequired(false)}
            />
            <label className="form-check-label" htmlFor="flexRadioDefault2">
              No
            </label>
          </div>
        </div>
        <p>If No, please enter Manual Invoice Number</p>
        <input
          type="text"
          className="form-control mt-2"
        // value={poNumber}
        // onChange={(e) => setPoNumber(e.target.value)}
        />

        <div className="d-flex justify-content-center gap-2 mt-4">
          <Buttons
            buttonText="Submit"
            buttonTypeClassName="success-btn"
          // onClick={onApproveClick}
          />
        </div>
      </CenterModel>
    </div>
  );
};

export default GenerateInvoiceList;
